var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonsystemsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Falkon_SYSTEMS-01",
    "data-name": "Falkon SYSTEMS-01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.665,
    height: 13.724,
    viewBox: "0 0 9.665 13.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M177.708,215.733a9.652,9.652,0,0,1-2.77-3.333,3.594,3.594,0,0,0-.448,1.231c-.045.394-.277,1.574,2.121,3.222,1.645,1.131,2.3,1.938,2.327,2.982-.488-1.954-4.5-2.956-4.763-4.455-.3,2.334.794,3.588,2.931,4.827,2.721,1.576-.482,4.485-2.957,5.918,3.195-1.409,4.781-2.693,5.684-4.5C180.777,219.739,180.358,217.591,177.708,215.733Z",
    transform: "translate(-174.125 -212.4)",
    fill: "#647084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M587.516,603.657a4.352,4.352,0,0,0-2.6.4,4.087,4.087,0,0,1-.114,5.252,6.765,6.765,0,0,1-1.306,1.546h0a10.285,10.285,0,0,0,3.247-4.279l.036-.113c.794-2.235,2.229-1.523,2.23-1.523A2.1,2.1,0,0,0,587.516,603.657Z",
    transform: "translate(-579.348 -599.601)",
    fill: "#647084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonsystemsIcon);
export default __webpack_public_path__ + "static/media/falkonsystems-icon.76bf5f4458871a866a81471be96d156b.svg";
export { ForwardRef as ReactComponent };